import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSubscription } from '../../contexts/SubscriptionContext'
import { Lock, Loader2 } from 'lucide-react'

interface SubscriptionGuardProps {
  children: React.ReactNode
}

export const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({ children }) => {
  const { hasActiveSubscription, isLoading } = useSubscription()
  const navigate = useNavigate()

  console.log('[SubscriptionGuard] Rendering - isLoading:', isLoading, 'hasActiveSubscription:', hasActiveSubscription)

  // Show loading state
  if (isLoading) {
    console.log('[SubscriptionGuard] Showing loading state')
    return (
      <div className="min-h-screen bg-gradient-to-br from-dark-primary via-dark-secondary to-dark-tertiary flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary-400 animate-spin mx-auto mb-4" />
          <p className="text-light-secondary">Checking subscription status...</p>
        </div>
      </div>
    )
  }

  // Show paywall if no active subscription
  if (!hasActiveSubscription) {
    console.log('[SubscriptionGuard] NO ACTIVE SUBSCRIPTION - Showing paywall')
    return (
      <div className="min-h-screen bg-gradient-to-br from-dark-primary via-dark-secondary to-dark-tertiary flex items-center justify-center px-4">
        <div className="max-w-2xl w-full">
          <div className="bg-dark-secondary/50 backdrop-blur-sm border border-primary-600/20 rounded-3xl p-12 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-primary-600 to-secondary-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <Lock className="w-10 h-10 text-white" />
            </div>

            <h2 className="text-3xl font-bold text-light-primary mb-4">
              Subscription Required
            </h2>

            <p className="text-xl text-light-secondary mb-8">
              Access to BLP Assistant requires an active subscription. Start your 7-day free trial to unlock unlimited AI-powered sales support.
            </p>

            <div className="space-y-4">
              <button
                onClick={() => navigate('/')}
                className="w-full px-8 py-4 bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white rounded-xl font-semibold text-lg shadow-xl transition-all transform hover:scale-105"
              >
                View Pricing & Start Free Trial
              </button>

              <button
                onClick={() => navigate(-1)}
                className="w-full px-8 py-4 bg-dark-tertiary hover:bg-dark-quaternary text-light-primary rounded-xl font-semibold text-lg border border-primary-600/30 transition-colors"
              >
                Go Back
              </button>
            </div>

            <div className="mt-8 pt-8 border-t border-primary-600/20">
              <p className="text-sm text-light-tertiary mb-4">
                7-day free trial
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Show protected content with subscription banner
  console.log('[SubscriptionGuard] ACCESS GRANTED - Rendering protected content')
  return <>{children}</>
}
